import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to remove the tenant part of an email
 * @param value the email to remove the tenant part from
 * @example
 * 'xxx_user@example.de' -> 'user@example.de'
 * @return the email without the tenant part
 */
@Pipe({
  name: 'tenantlessEmail'
})
export class TenantlessEmailPipe implements PipeTransform {
  /**
   * Pipe to remove the tenant part of an email
   * @param value the email to remove the tenant part from
   * @example
   * 'xxx_user@example.de' -> 'user@example.de'
   * @return the email without the tenant part
   */
  transform(value: string): string {
    if (value) {
      const emailParts = value.split('_');
      switch (emailParts.length) {
        case 1:
          return value;
        case 2:
          return emailParts[1];
        default: {
          emailParts.shift();
          return emailParts.join('_');
        }
      }
    }
    return '';
  }
}
